/* eslint-disable no-nested-ternary */

import styled from 'styled-components';
import ReactLoading from 'react-loading';
import Stepper from '@material-ui/core/Stepper';

export const Container = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const WrapperBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`;

export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const WrapperBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px solid #e5e5e5;
  gap: 10px;
`;

export const BottomText = styled.a`
  font-size: 16px;
  font-weight: 700;
  color: #122d58;
  cursor: pointer;
  padding: 5px 20px;
`;

export const WrapperInput = styled.div`
  margin-bottom: 15px;
  flex: 1;
`;

export const InputRow = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;

  > ${WrapperInput} {
    flex: 1 1 calc(33.333% - 10px);
    min-width: 200px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
    > ${WrapperInput} {
      min-width: 100%;
      flex: 1 1 100%;
    }
  }
`;

export const SectionTitle = styled.h3`
  color: #122D58;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
`;

export const Column = styled.div`
  flex: 1;
`;

export const Center = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Loading = styled(ReactLoading).attrs({
  color: '#122d58',
})``;

export const Line = styled.div`
  background-color: #e5e5e5;
  height: 1px;
  width: 100%;
  margin: 20px 0;
`;

export const StepperMUI = styled(Stepper)`
  & .MuiStepIcon-root.MuiStepIcon-active {
    color: #fff28d;
  }
  & .MuiStepIcon-text {
    fill: #122d58;
    font-weight: bold;
  }
  & .MuiStepLabel-label.MuiStepLabel-active {
    color: #a5a5a5;
  }

  & .MuiStepIcon-completed {
    fill: #122d58;
  }
`;

export const BoxMap = styled.div`
  width: 100%;
  height: 250px;
`;

export const BoxSearch = styled.div`
  height: 32px;
  padding: 0 12px;
  border: 1px solid ${(props) => (props.error ? '#F27160' : '#ebebeb')};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImgFlag = styled.img`
  height: 18px;
  object-fit: contain;
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

